import { render, staticRenderFns } from "./survey-step-pregnancy.vue?vue&type=template&id=4bf1fadb"
import script from "./survey-step-pregnancy.vue?vue&type=script&lang=js"
export * from "./survey-step-pregnancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports